import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth";
import { cmsHost } from "../lib/languages";

export function LoginPage() {
  const { configured, sessionToken, isAdmin, signInWithApple, loading } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const host = cmsHost();

  if (!loading && sessionToken && isAdmin) {
    return <Navigate to="/" replace />;
  }

  async function onAppleClick() {
    setBusy(true);
    setError(null);
    try {
      await signInWithApple();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sign-in failed.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <div className="panel login-card stack">
        <div className="login-hero">
          <div className="logo" aria-hidden="true">
            G
          </div>
          <h1>GospelGo</h1>
          <p>{host}</p>
        </div>

        <p className="login-body">
          Sign in to review drafts and publish daily readings to CloudKit Public.
        </p>

        {!configured && (
          <div className="error-banner" role="alert">
            Missing <code>VITE_APPLE_CLIENT_ID</code>. Add the Services ID to{" "}
            <code>.env.local</code> and rebuild.
          </div>
        )}

        {error && (
          <div className="error-banner" role="alert">
            {error}
          </div>
        )}

        <button
          className="btn btn-primary btn-block"
          type="button"
          disabled={!configured || busy || loading}
          onClick={() => void onAppleClick()}
        >
          {busy ? "Signing in…" : "Sign in with Apple"}
        </button>

        <p className="login-foot">
          Access is limited to allowlisted Apple accounts (
          <code>APPLE_ADMIN_SUBS</code> / <code>APPLE_ADMIN_EMAILS</code>).
        </p>

        <p className="login-foot">
          Services ID expected: <code>dev.disguised.gospelgo.cms</code>
          <br />
          Domain: <code>cms.gospelgo.app</code> · Return URL:{" "}
          <code>https://cms.gospelgo.app/auth/callback</code>
        </p>
      </div>
    </div>
  );
}
